<template>
  <div>
    <div v-html="description" />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  description: string
}>()
</script>

<style>
.fm-h4 {
  @apply py-4 text-base font-semibold;
}
</style>
